import { useQuery } from '@tanstack/react-query';
import { adminApi } from '@/lib/adminApi';
import { schoolList } from '@/lib/sources';
import { AdminPage } from '@/admin';

export function SchoolsPage() {
  const q = useQuery({ queryKey: ['sources'], queryFn: () => adminApi.sources.list() });
  const schools = schoolList(q.data);
  return (
    <AdminPage title="Research schools" description="Research-provenance traditions that decide which sources reach the board. A school contains sources; ResearchDB chunks are tagged with the source they came from. Read-only (authored via seed).">
      {q.isLoading ? <p className="text-body-sm text-text-muted">Loading…</p> : null}
      {q.isError ? <p className="text-body-sm text-flagged">Could not load sources.</p> : null}
      <div className="flex flex-col gap-21">
        {schools.map((s) => (
          <section key={s.school}>
            <h2 className="mb-8 text-h3 font-semibold capitalize">
              {s.school} <span className="text-[12px] font-normal text-text-muted">· {s.sources.length} sources</span>
            </h2>
            <div className="overflow-x-auto rounded border border-border bg-surface">
              <table className="w-full border-collapse text-body-sm">
                <thead>
                  <tr className="border-b border-border-strong text-left text-[12px] uppercase tracking-wide text-text-secondary">
                    <th className="p-2 font-semibold">Source</th><th className="p-2 font-semibold">Label</th><th className="p-2 font-semibold">Description</th>
                  </tr>
                </thead>
                <tbody>
                  {s.sources.map((src) => (
                    <tr key={src.id} className="border-b border-border">
                      <td className="p-2 font-mono text-[12px]">{src.id}</td>
                      <td className="p-2">{src.label}</td>
                      <td className="p-2 max-w-[520px] text-[12px] text-text-secondary">{src.description}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>
        ))}
      </div>
    </AdminPage>
  );
}
